export default {
    label_task:{
        en:"Crop Features",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Feature",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Feature",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Feature",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_crop_id:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },
    label_crop_name:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },
}